import { afterNextRender, Component, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { filter, Subject, takeUntil } from 'rxjs';
import { AnalyticsService } from './services/analytics/analytics.service';
import { SeoService } from './services/seo/seo.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ToastModule, RouterOutlet, ButtonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  translocoService = inject(TranslocoService);
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    private readonly seoService: SeoService,
    private readonly renderer: Renderer2,
    private readonly _analytics: AnalyticsService,
  ) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }, 100);
      }
    });

    afterNextRender({
      read: () => {
        const loader = this.renderer.selectRootElement('#loader');
        this.renderer.setStyle(loader, 'display', 'none');
      },
    });
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }, 100);

        // Aggiorna canonical tag
        this.seoService.setCanonicalURL();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
